import QuestionInfo from './QuestionInfo';

export default QuestionInfo;
